import React from "react";
import Select, { components } from 'react-select';
import { COUNTRY_CODE } from '@src/config/constant';

const CustomValueContainer = ({ children, ...props }: any) => {
    const { ValueContainer, Placeholder } = components;

    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, child =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

const ReactSelect = (props: any) => {
     const isCountryId = COUNTRY_CODE ==='id' ? true : false;
    const handleMenuOpen = () => {
        if (typeof props.onClick === 'function') {
            props.onClick(props.fieldItem);
        }
    };

    return (
        <>
            <fieldset className={`single-select ${props.fieldSetClassName || ""} ${(props.fieldItemName === "lead_source" && ![3, 4, 5, 7].includes(props?.value?.value)) ? "p-b-50" : ""} `} key={props.key || "reactSelect"}>
                <div className={props?.disableMargin ? '' : "material " + props?.innerClass ? props?.innerClass : ''}>
                    <Select
                        components={{ ValueContainer: CustomValueContainer }}
                        options={props.options || []}
                        value={props.value}
                        onChange={(e: any) => props.handleChange(e, props.fieldKey)}
                        placeholder={props.placeholder}
                        className='react-select'
                        classNamePrefix='react-select'
                        isDisabled={props.isDisabled}
                        isOptionDisabled={(option) => option.disabled}
                        menuIsOpen={props.fieldKey === 'agency' ? props.menuIsOpen : undefined}
                        onMenuOpen={
                            isCountryId
                                ? () => {
                                    if (!props?.fieldItem) return;
                                    props.onClick(props.fieldItem);
                                }
                                : handleMenuOpen
                        }
                    />

                    {props?.errorField ? <span className="error-txt">{props.errorField}</span> : null}
                    {
                     props?.note && <span className="select-note">{props?.note}</span>
                    }

                </div>
            </fieldset>
        </>
    );
};

export default ReactSelect;